<template>
    <app-transition>
        <Dialog :only-text="true" @close="handleClose">
            <div>
                <span class="d-block">
                    {{ $t('dialogs.dream_goals.form_title') }}
                </span>
                <strong>{{ dreamGoal.name }}</strong>
            </div>

            <v-row class="w-full">
                <v-col cols="10" class="px-0">
                    <v-progress-linear class="me-2 d-flex align-center"
                        :value="progressGoal"
                        :width="5"
                        :color="progressGoalColor"
                        height="24"
                        striped
                        rounded
                    >
                        <template v-slot:default>
                            <span class="dream-goal-price">{{ Number(dreamGoal.collected_tips) }} / {{ Number(dreamGoal.price) }} {{ currency }} </span>
                        </template>
                    </v-progress-linear>
                </v-col>
                <v-col cols="2" class="px-0 d-flex" justify="end">
                    <span class="text-end w-full">{{ progressGoal.toFixed(0) }}%</span>
                </v-col>
            </v-row>
            
            <div class="w-full d-block text-start d-flex align-center">
                <v-icon class="me-2">mdi-account-group</v-icon>
                <span class="mb-0">{{ this.$tc('dialogs.dream_goals.contributors', this.contributors, { no: this.contributors }) }}</span>
            </div>
            <template>
                <v-row align="center" justify="center" no-gutters class="mt-6">
                    <v-col cols="2" v-for="(item, i) in tips " :key="i" class="mr-4">
                        <div @click="activeTip = i; model.tip=item;" :class="{'select-tip': true, active: i === activeTip}">
                            {{ formatPrice(item) }}
                        </div>
                    </v-col>
                    <v-col cols="3">
                        <v-text-field
                            @click="model.tip = inputTip; activeTip = -1;"
                            @input="model.tip = inputTip"
                            hide-details
                            outlined
                            dense
                            :suffix="currency"
                            v-mask="`###`"
                            v-model="inputTip"
                            text-center
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row v-if="isTipNull" class="w-full mt-2 ml-3" align="center">
                    <span class="red--text"><strong>* </strong>
                        {{ $t("dialogs.invalid_tip") }}
                    </span>
                </v-row>
                <v-row justify="center" class="w-full mt-5">
                    <v-col>
                        <v-btn
                            outlined
                            block
                            @click="save"
                            :loading="$store.getters.loadingBtn(['setting', 'dreamGoalTipSendBtn']) || loading"
                        >
                        {{ this.$t('dialogs.dream_goals.send_tip') }}
                    </v-btn>
                    </v-col>
                </v-row>
            </template>
        </Dialog>
    </app-transition>
</template>

<script>
import Radio from "@/components/app/form/Radio";
import {CURRENCY_SYMBOL} from "@/configs/constants";
import Dialog from "@/components/app/form/Dialog";

export default {
    name: "CreatorDreamGoalDialog.",
    data: () => ({
        model: {
            radio: 'send',
            tip: 10,
            text: '',
        },
        tips: [5, 10, 15],
        inputTip: '',
        activeTip: 1,
        hidden: true,
        currency: CURRENCY_SYMBOL,
        isTipNull: false,
        progressGoalColor: '#DD3500',
    }),
    props: {
        loading: {
            default: false
        },
        dreamGoal: {
            type: Object,
        },
        contributors: {
            type: Number,
        },
    },
    computed: {
        currentTip() {
            return this.tips[this.activeTip];
        },
        progressGoal() {       
            if (this.dreamGoal) {
                return (this.dreamGoal.collected_tips / this.dreamGoal.price) * 100;
            }
        },
    },
    watch: {
        dreamGoal: {
            handler(newVal) {
                if (newVal.collected_tips >= newVal.price && newVal.is_achieved !== 1) {
                    this.handleGoalCompletion();
                }
                if (newVal.collected_tips >= newVal.price) {
                    this.progressGoalColor = '#50C878';
                }
            },
            deep: true,
            immediate: true,
        }
    },
    methods: {
        save() {
            if (!this.model.tip || this.model.tip == 0) {
                this.isTipNull = true;
                return;
            }

            this.$emit('save', this.model);
            this.inputTip = '';
            this.model = {
                ...{
                    radio: 'send',
                    tip: this.currentTip,
                    text: '',
                },
            }
        },

        formatPrice(price) {
            return price + this.currency;
        },

        handleClose() {
            this.$emit('close');
        },

        async handleGoalCompletion() {
            try {
                await axios.post(`/api/creator/${this.dreamGoal.id}/goal-completed`, {
                    is_achieved: true
                });
            } catch (error) {
                console.error("Failed to update goal status:", error);
            }
        },
    },
    components: {
        Radio,
        Dialog
    }
}
</script>

<style scoped lang="scss">
@import '@/sass/modules/_variables';

.InformMessage {
    &-title {
        font-size: 20px;
        font-weight: bold;
        line-height: 19px;
        margin: 8px 0;
        display: flex;
        justify-content: center;
    }
}

.select-tip {
    background: rgba(237, 237, 237, .3);
    border-radius: 6px;
    padding: 9px;
    width: 100%;
    text-align: center;

}

.select-tip.active {
    background-image: $accent-background;
    color: white
}

.border {
    border: 1px solid rgba(65, 65, 69, .3)
}

.dream-goal-name {
    font-size: 0.9em;
    font-weight: bold;
}

.dream-goal-price {
    position: absolute;
    right: 10px;
    font-size: 0.9em;
    font-weight: bold;
}
</style>
